import React from 'react'

import BaseMakeDropdown from 'components/BaseMakeDropdown'

interface VehicleMakeDropdownProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formik: any
    assetType?: string
    disable?: boolean
    dataSource?: string[]
    primaryVehicleId?: number
}

export default function MakeDropdown(
    props: Readonly<VehicleMakeDropdownProps>,
) {
    return (
        <BaseMakeDropdown
            {...props}
            dropdownType="vehicle"
            fieldNamePrefix="vehicle"
        />
    )
}
